import React, { useEffect, useState, useRef } from "react";
import ReactModal from "react-modal";
import "./add-pricing-equipment-modal.scss";
import PricingModel from "./v2/PricingModel";
import { FaTimes } from "react-icons/fa";
import { IoMdCheckmark } from "react-icons/io";
import {
    GetMccList,
    assignPEToApp,
    getEquipments,
    getPreappById,
    getMerchantInfo,
    saveTemplates, getEmsOfficesById,
    getTemplateForApplication
} from "../../../api";
import config from "../../../config";
import LineItems from "./v2/LineItems";
import { Form } from "react-bootstrap";
import _ from "lodash";
import eventEmitter from "./eventEmitter";
import SlidingButton from "./v2/input-elements/SlidingButton";
import BatchTime from "./v2/input-elements/BatchTime";
import { EquipmentContext } from "./useContext/context";
import { Stack } from "@mui/material";
import pricingValidation from "./pricing-validation";
import { EMS_OTHER_DEFAULT_FEE, PAYCHEX_OTHER_DEFAULT_FEE } from "../../../constants";
import AddedItemCount from "./v2/AddedItemCount";
import Loader from "../../loader/loader";
import Select from "react-select";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import AssignBankModal from "../assign-bank-modal/assign-bank-modal";

const MySwal = withReactContent(Swal);

const pricing_model_options = [
    { label: "Dual Pricing", type: "dual_pricing" },
    { label: "Surcharge", type: "surcharge" },
    { label: "Flat Rate", type: "flat_rate" },
    { label: "Tiered Rate", type: "tiered" },
    { label: "IC+", type: "ic_plus" },
];

const MAIN_URL = config.paymentcloud.APPLICATION_URL;
const PAYCHEX_ORG_ID = config.paymentcloud.PAYCHEX_ORG_ID;
const EMS_ORG_ID = config.paymentcloud.EMS_ORG_ID;
const dual_pricing_validation =
    pricingValidation.pricingValidation.dual_pricing;
const flat_rate_validation = pricingValidation.pricingValidation.flat_rate;
const ic_plus_validation = pricingValidation.pricingValidation.ic_plus;
const surcharge_validation = pricingValidation.pricingValidation.surcharge;
const tiered_validation = pricingValidation.pricingValidation.tiered;

function AddPricingEquipmentModal(props) {
    const [assignBankModal, setAssignBankModal] = useState("");
    const [isOpen, setIsOpen] = useState(true);
    const [org_id, setOrgId] = useState(props?.user?.organization_id);
    const [mccList, setMccList] = useState([]);
    const [emsOfficeList, setEmsOfficeList] = useState([]);
    let other_default_fee = {};
    if (org_id == config.paymentcloud.PAYCHEX_ORG_ID) {
        other_default_fee = PAYCHEX_OTHER_DEFAULT_FEE;
    } else {
        other_default_fee = EMS_OTHER_DEFAULT_FEE;
    }
    const [form_data, setFormData] = useState({
        template_name: "",
        mcc_id: "",
        ems_office_id: "",
        // dba_name: "",
        // first_name: "",
        // last_name: "",
        // email: "",
        // mobile: "",
        // dba_street: "",
        // dba_city: "",
        // dba_state: "",
        // dba_zip: "",
        is_editable: "yes",

        selected_template: "",
        qualifiedtype: "dual_pricing",
        pricing_model: "",

        dual_pricing_rate: dual_pricing_validation.dual_pricing_rate.default,
        dual_pricing_monthly_fee:
            dual_pricing_validation.dual_pricing_monthly_fee.default.toFixed(2),
        dual_pricing_pin_debit_network_fee:
            dual_pricing_validation.dual_pricing_pin_debit_network_fee.default,
        dual_pricing_pin_debit_rate:
            dual_pricing_validation.dual_pricing_pin_debit_rate.default.toFixed(
                2,
            ),
        dual_pricing_pin_debit_per_transaction:
            dual_pricing_validation.dual_pricing_pin_debit_per_transaction.default.toFixed(
                2,
            ),

        surcharge_rate: surcharge_validation.surcharge_rate.default.toFixed(2),
        surcharge_per_transaction:
            surcharge_validation.surcharge_per_transaction.default.toFixed(2),
        surcharge_monthly_fee:
            surcharge_validation.surcharge_monthly_fee.default.toFixed(2),
        surcharge_qual_debit_rate:
            surcharge_validation.surcharge_qual_debit_rate.default.toFixed(2),
        surcharge_qual_debit_per_transaction:
            surcharge_validation.surcharge_qual_debit_per_transaction.default.toFixed(
                2,
            ),
        surcharge_mid_qual_debit_rate:
            surcharge_validation.surcharge_mid_qual_debit_rate.default.toFixed(
                2,
            ),
        surcharge_mid_qual_debit_per_transaction:
            surcharge_validation.surcharge_mid_qual_debit_per_transaction.default.toFixed(
                2,
            ),
        surcharge_non_qual_debit_rate:
            surcharge_validation.surcharge_non_qual_debit_rate.default.toFixed(
                2,
            ),
        surcharge_non_qual_debit_per_transaction:
            surcharge_validation.surcharge_non_qual_debit_per_transaction.default.toFixed(
                2,
            ),
        surcharge_pin_debit_rate:
            surcharge_validation.surcharge_pin_debit_rate.default.toFixed(2),
        surcharge_pin_debit_per_transaction:
            surcharge_validation.surcharge_pin_debit_per_transaction.default.toFixed(
                2,
            ),
        surcharge_signature_debit_rate:
            surcharge_validation.surcharge_signature_debit_rate.default.toFixed(
                2,
            ),
        surcharge_signature_debit_per_transaction:
            surcharge_validation.surcharge_signature_debit_per_transaction.default.toFixed(
                2,
            ),
        surcharge_pin_debit_network_fee:
            surcharge_validation.surcharge_pin_debit_network_fee.default,

        flat_rate: flat_rate_validation.flat_rate.default.toFixed(2),
        flat_rate_transaction:
            flat_rate_validation.flat_rate_transaction.default.toFixed(2),
        flat_rate_amex: flat_rate_validation.flat_rate_amex.default.toFixed(2),
        flat_rate_amex_transaction:
            flat_rate_validation.flat_rate_amex_transaction.default.toFixed(2),
        flat_rate_pin_debit_network_fee:
            flat_rate_validation.flat_rate_pin_debit_network_fee.default,
        flat_rate_pin_debit_rate:
            flat_rate_validation.flat_rate_pin_debit_rate.default.toFixed(2),
        flat_rate_pin_debit_per_transaction:
            flat_rate_validation.flat_rate_pin_debit_per_transaction.default.toFixed(
                2,
            ),

        tiered_qual_rate: tiered_validation.tiered_qual_rate.default.toFixed(2),
        tiered_qual_transaction:
            tiered_validation.tiered_qual_transaction.default.toFixed(2),
        tiered_qual_debit_rate:
            tiered_validation.tiered_qual_debit_rate.default.toFixed(2),
        tiered_qual_debit_per_transaction:
            tiered_validation.tiered_qual_debit_per_transaction.default.toFixed(
                2,
            ),

        tiered_mid_qual_rate:
            tiered_validation.tiered_mid_qual_rate.default.toFixed(2),
        tiered_mid_qual_transaction:
            tiered_validation.tiered_mid_qual_transaction.default.toFixed(2),
        tiered_mid_qual_debit_rate:
            tiered_validation.tiered_mid_qual_debit_rate.default.toFixed(2),
        tiered_mid_qual_debit_per_transaction:
            tiered_validation.tiered_mid_qual_debit_per_transaction.default.toFixed(
                2,
            ),

        tiered_non_qual_rate:
            tiered_validation.tiered_non_qual_rate.default.toFixed(2),
        tiered_non_qual_transaction:
            tiered_validation.tiered_non_qual_transaction.default.toFixed(2),
        tiered_non_qual_debit_rate:
            tiered_validation.tiered_non_qual_debit_rate.default.toFixed(2),
        tiered_non_qual_debit_per_transaction:
            tiered_validation.tiered_non_qual_debit_per_transaction.default.toFixed(
                2,
            ),


        amex_tier_one_rate:
            tiered_validation.amex_tier_one_rate.default.toFixed(2),
        amex_tier_one_fee:
            tiered_validation.amex_tier_one_fee.default.toFixed(2),
        amex_tier_two_rate:
            tiered_validation.amex_tier_two_rate.default.toFixed(2),
        amex_tier_two_fee:
            tiered_validation.amex_tier_two_fee.default.toFixed(2),
        amex_tier_three_rate:
            tiered_validation.amex_tier_three_rate.default.toFixed(2),
        amex_tier_three_fee:
            tiered_validation.amex_tier_three_fee.default.toFixed(2),
        amex_tier_four_rate:
            tiered_validation.amex_tier_four_rate.default.toFixed(2),
        amex_tier_four_fee:
            tiered_validation.amex_tier_four_fee.default.toFixed(2),

        tiered_amex_flat_rate:
            tiered_validation.tiered_amex_flat_rate.default.toFixed(2),
        tiered_amex_flat_transaction:
            tiered_validation.tiered_amex_flat_transaction.default.toFixed(2),

        tiered_amex_ic_plus_rate:
            tiered_validation.tiered_amex_ic_plus_rate.default.toFixed(2),
        tiered_amex_ic_plus_transaction:
            tiered_validation.tiered_amex_ic_plus_transaction.default.toFixed(
                2,
            ),

        tiered_pin_debit_network_fee:
            tiered_validation.tiered_pin_debit_network_fee.default,
        tiered_pin_debit_rate:
            tiered_validation.tiered_pin_debit_rate.default.toFixed(2),
        tiered_pin_debit_per_transaction:
            tiered_validation.tiered_pin_debit_per_transaction.default.toFixed(
                2,
            ),

        ic_plus_rate: ic_plus_validation.ic_plus_rate.default.toFixed(2),
        ic_plus_transaction_fee:
            ic_plus_validation.ic_plus_transaction_fee.default.toFixed(2),
        ic_plus_amex_rate:
            ic_plus_validation.ic_plus_amex_rate.default.toFixed(2),
        ic_plus_amex_transaction_fee:
            ic_plus_validation.ic_plus_amex_transaction_fee.default.toFixed(2),
        ic_plus_pin_debit_network_fee:
            ic_plus_validation.ic_plus_pin_debit_network_fee.default,
        ic_plus_pin_debit_rate:
            ic_plus_validation.ic_plus_pin_debit_rate.default.toFixed(2),
        ic_plus_pin_debit_per_transaction:
            ic_plus_validation.ic_plus_pin_debit_per_transaction.default.toFixed(
                2,
            ),

        monthly_fee: "49.00",

        other_gateway: "",

        pricing_approved_by_rate_desk: "no",

        equipments: {},
        var_only: {},
        override_bank: {},
        override_addendums: {},
        ...other_default_fee,

        // merchant referral
        is_merchant_referral: "no",
        referrer_name: "",
        referrer_mid: "",
        is_tm: "no",
        telemarketer_name: "",
        cold_call: "no",
        tm_lead: "no",

        //EBT
        ebt: "no",
        fnf_number: "",
        ebt_transactions: "",

        country: "en",
        var_sheet_request: "yes",
        who_to_deploy_equipment: "agent",
        who_to_pay_for_equipment: "agent",
        who_to_deploy_gateway: "agent",
        reprogram_equipment: true,
        reprogram_equipment_name: "",

        postal_code: "",
    });

    const [reimbursementMaximum, setReimbursementMaximum] = useState();
    const [coverCancellation, setCoverCancellation] = useState("no");
    const [expedited_funding, setExpeditedFunding] = useState("yes");
    const [billing_sequence, setBillingSequence] = useState("daily");
    const [batch_time, setBatchTime] = useState("06:00 PM");
    const [equipment_address, setEquipmentAddress] = useState("");
    const [invoice_address, setInvoiceAddress] = useState("");
    const [special_instructions, setSpecialInstruction] = useState("");
    const [errors, setErrors] = useState({});
    const [allEquipments, setAllEquipments] = useState({});
    const [isDeviceExpanded, setIsDeviceExpanded] = useState(false);
    const [categories_selected, setCategoriesSelected] = useState([]);
    const [equipment_count, setEquipmentCount] = useState(0);
    const [tpp_equipments_selected, setTppEquipmentsSelected] = useState([]);
    const [all_equipment_list, setAllEquipmentList] = useState([]);
    const [preappData, setPreappData] = useState({});
    const [var_only, setVarOnly] = useState(null);
    const [preappBillingData, setPreappBillingData] = useState([]);

    const [all_templates, setAllTemplates] = useState([]);
    const [templateOptions, setTemplateOptions] = useState([]);
    const [isEditable, setIsEditable] = useState(true);

    useEffect(() => {
        getEquipments()
            .then((res) => {
                const result = res.data.equipments.reduce((acc, current) => {
                    acc[current.id] = current.equipment_name;
                    return acc;
                }, {});
                setAllEquipments(result);
                setAllEquipmentList(res.data.equipments);
            })
            .catch((err) => {
            });

        if (props.template) {
            getEmsOfficesById().then(response => {
                if (response.status) {
                    setEmsOfficeList(response.data);
                }
            });
            GetMccList().then(response => {
                const mccOption = response.data.map((t) => {
                    return {
                        value: t.id,
                        label: t.description,
                        mcc_id: t.mcc,
                    };
                });
                setMccList(mccOption);
            });
            let recordToEditData = props?.recordToEdit?.data;
            setFormData({
                ...form_data,
                ...recordToEditData,
                template_name: props?.recordToEdit?.name,
                is_editable: props?.recordToEdit?.is_editable == 1 ? "yes" : "no",
            });
            setPreappBillingData({
                status: true,
                billing: {
                    qualifiedtype: recordToEditData?.qualifiedtype,
                    pricing_model: recordToEditData?.pricing_model,
                    equipment_json: JSON.stringify(recordToEditData?.equipments),
                }
            });
            setExpeditedFunding(recordToEditData?.expedited_funding ? recordToEditData?.expedited_funding : "yes");
            setBatchTime(recordToEditData?.batch_time ? recordToEditData?.batch_time : "06:00 PM");
            setBillingSequence(recordToEditData?.billing_sequence ? recordToEditData?.billing_sequence : "daily");
            setInvoiceAddress(recordToEditData?.invoice_address ? recordToEditData?.invoice_address : "");
            setEquipmentAddress(recordToEditData?.equipment_address ? recordToEditData?.equipment_address : "");
            setSpecialInstruction(recordToEditData?.special_instructions ? recordToEditData?.special_instructions : "");

        } else {
            getPreappById({ id: props.appId }).then((res) => {
                setPreappData(res);
            });
            getMerchantInfo({ id: props.appId }).then((res) => {
                setPreappBillingData(res);
                if (res?.status) {
                    setExpeditedFunding(res?.billing?.expedited_funding ? res?.billing?.expedited_funding : "yes");
                    setBatchTime(res?.billing?.batch_time ? res?.billing?.batch_time : "06:00 PM");
                    setBillingSequence(res?.billing?.billing_sequence ? res?.billing?.billing_sequence : "daily");
                    setInvoiceAddress(res?.billing?.invoice_address ? res?.billing?.invoice_address : "");
                    setEquipmentAddress(res?.billing?.equipment_address ? res?.billing?.equipment_address : "");
                    setSpecialInstruction(res?.billing?.special_instruction ? res?.billing?.special_instruction : "");
                }
            });
        }

        getTemplateForApplication()
        .then((res) => {
          if(res.status){
            setAllTemplates(res.data);
            setTemplateOptions(res.data.map((template) => ({
              label: template.name,
              value: template.id,
            })));
          }
        })
        .catch((err) => {
            console.log(err);
        });

    }, []);

    useEffect(() => {
        if (preappData?.data?.var_only) {
            const varData = preappData.data.var_only;
            const varOnlyData = {
                type: varData.equipment_type,
                model: varData.equipment_type == "terminal" ? varData.terminal_model : varData.gateway_name,
                serial: varData.equipment_type == "terminal" ? varData.terminal_serial : null,
            };
            setVarOnly(varOnlyData);
        }
    }, [preappData]);

    useEffect(() => {
        setFormData((prevState) => ({
            ...prevState,
            var_only: var_only,
        }));
        removeError(['equipments', 'equipment_address', 'invoice_address', 'var_only', 'var_only.type', 'var_only.model', 'var_only.serial']);
    }, [var_only]);

    const setFormDataByComplete = (formData) => {
        if (formData) {
            setFormData((prevState) => ({
                ...prevState,
                ...formData,
            }));
        }
    }
    const setFormDataByKeyValue = (key, value) => {
        // Skip if we're applying a template
        if (Object.entries(pricing_template_data).length > 0 && key == "equipments") {
          return;
        }

        if (key == "pricing_model") {
            if (["dual_pricing", "surcharge"].includes(value)) {
                setBillingSequence("daily");
            }
        }
        setFormData((prevState) => ({
            ...prevState,
            [key]: value,
        }));
        removeError(key);
    };

    const removeError = (keys) => {
        setErrors((prevErrors) => {
            const keysToRemove = Array.isArray(keys) ? keys : [keys];
            const newErrors = { ...prevErrors };
            
            keysToRemove.forEach((key) => {
                delete newErrors[key];
            });
    
            return newErrors;
        });
    };

    const setAddressByGoogleAPI = (address) => {
        setFormData((prevState) => ({
            ...prevState,
            ...address,
        }));

        setTimeout(() => {
            setErrors((prevErrors) => {
                const { dba_street, dba_city, dba_zip, dba_state, ...rest } =
                    prevErrors;
                return rest;
            });
        }, 500);
    };

    const skipCheck = (field) => {
        if (field == "dual_pricing_pin_debit_network_fee") return false;
        if (field == "flat_rate_pin_debit_network_fee") return false;
        if (field == "tiered_pin_debit_network_fee") return false;
        if (field == "ic_plus_pin_debit_network_fee") return false;
        if (field == "surcharge_pin_debit_network_fee") return false;

        if (form_data.pricing_model == "tiered") {
            if (field == "tiered_amex_flat_rate") return false;
            if (field == "tiered_amex_flat_transaction") return false;
            if (field == "tiered_amex_ic_plus_rate") return false;
            if (field == "tiered_amex_ic_plus_transaction") return false;
        }

        if (form_data.pricing_model == "flat_rate") {
            if (field == "tiered_amex_ic_plus_rate") return false;
            if (field == "tiered_amex_ic_plus_transaction") return false;

            if (field == "amex_tier_one_rate") return false;
            if (field == "amex_tier_one_fee") return false;
            if (field == "amex_tier_two_rate") return false;
            if (field == "amex_tier_two_fee") return false;
            if (field == "amex_tier_three_rate") return false;
            if (field == "amex_tier_three_fee") return false;
            if (field == "amex_tier_four_rate") return false;
            if (field == "amex_tier_four_fee") return false;
        }

        if (form_data.pricing_model == "ic_plus") {
            if (field == "tiered_amex_flat_rate") return false;
            if (field == "tiered_amex_flat_transaction") return false;

            if (field == "amex_tier_one_rate") return false;
            if (field == "amex_tier_one_fee") return false;
            if (field == "amex_tier_two_rate") return false;
            if (field == "amex_tier_two_fee") return false;
            if (field == "amex_tier_three_rate") return false;
            if (field == "amex_tier_three_fee") return false;
            if (field == "amex_tier_four_rate") return false;
            if (field == "amex_tier_four_fee") return false;
        }

        if (
            form_data.qualifiedtype == "surcharge" &&
            form_data.pricing_model == "ic_plus"
        ) {
            if (field == "surcharge_qual_debit_rate") return false;
            if (field == "surcharge_qual_debit_per_transaction") return false;
            if (field == "surcharge_mid_qual_debit_rate") return false;
            if (field == "surcharge_mid_qual_debit_per_transaction")
                return false;
            if (field == "surcharge_non_qual_debit_rate") return false;
            if (field == "surcharge_non_qual_debit_per_transaction")
                return false;
        }

        if (
            form_data.qualifiedtype == "surcharge" &&
            form_data.pricing_model == "tiered"
        ) {
            if (field == "surcharge_signature_debit_rate") return false;
            if (field == "surcharge_signature_debit_per_transaction")
                return false;
        }

        return true;
    };

    const checkPricingValidation = () => {
        let validation_errors = {};
        let validations = {};
        if (form_data.pricing_model == "dual_pricing")
            validations = dual_pricing_validation;
        if (form_data.pricing_model == "surcharge")
            validations = surcharge_validation;
        if (form_data.pricing_model == "flat_rate")
            validations = flat_rate_validation;
        if (form_data.pricing_model == "tiered")
            validations = tiered_validation;
        if (form_data.pricing_model == "ic_plus")
            validations = ic_plus_validation;

        Object.entries(validations).forEach(([field, validation]) => {
            let value = parseFloat(form_data[field]);
            if (skipCheck(field)) {
            }
        });
        setErrors(validation_errors);
        return Object.entries(validation_errors).length > 0 ? true : false;
    };

    const submitForm = (e, save_type = 'save') => {
        e.preventDefault();
        if (checkPricingValidation()) {
            return;
        }
        if (props.template) {
            let data = {
                ...form_data,
                selectedOrg: props?.selectedOrg,
                selectedUser: props?.selectedUser,
                id: props?.recordToEdit?.id,
                template: props.template,
                is_tm: "no",
                reimbursement_maximum: reimbursementMaximum,
                cover_cancellation: coverCancellation,
                expedited_funding,
                billing_sequence,
                batch_time,
                equipment_address,
                invoice_address,
                special_instructions,
            };
            saveTemplates(data).then((res) => {
                props.close();
                props.refreshTemplateList();
                MySwal.fire({
                    title: <p>Template Saved</p>,
                    icon: "success",
                    toast: true,
                    position: "top-end",
                    timer: 4000,
                    timerProgressBar: true,
                    showConfirmButton: false,
                    customClass: "margin-top-sweetalert"
                });

            }).catch((error) => {
                if (error.status == 422) {
                    setErrors(error.data.errors);
                }
                // scrollToTop();
            });    

        } else {

            let data = {
                ...form_data,
                reimbursement_maximum: reimbursementMaximum,
                cover_cancellation: coverCancellation,
                expedited_funding,
                billing_sequence,
                batch_time,
                equipment_address,
                invoice_address,
                special_instructions,
                submission_type: "update_app",
                slug: props.slug,
                appId: props.appId,
                save_type: save_type,
            };
            assignPEToApp(data)
                .then((res) => {
                    if (props?.user?.organization_id != 1) {
                        props.close();
                        MySwal.fire({
                            title: <p>Pricing Equipment Saved</p>,
                            icon: "success",
                            toast: true,
                            position: "top-end",
                            timer: 4000,
                            timerProgressBar: true,
                            showConfirmButton: false,
                            customClass: "margin-top-sweetalert",
                        });
                    } else {
                        if (save_type == 'save') {
                            props.close();
                        } else {
                            setAssignBankModal(props.appId);    
                        }

                    }
                })
                .catch((error) => {
                    if (error.status == 422) {
                        setErrors(error.data.errors);
                    }
                    // scrollToTop();
                });    
        }

    };

    const scrollToTop = () => {
        if (modalContentRef.current) {
            modalContentRef.current.node
                .querySelector(".ems-boot-modal")
                .scrollTo({ top: 900, behavior: "smooth" });
        }
    };

    const modalContentRef = useRef(null);


    const addQuantity = (eqp, type, slug) => {
        let copy_eqp = form_data.equipments;
        copy_eqp[type][slug].push(eqp);
        setFormData({
            ...form_data,
            equipments: copy_eqp,
        });
    };

    const removeQuantity = (eqp, type, slug) => {
        let copy_eqp = form_data.equipments;
        let removed = copy_eqp[type][slug].pop();
        setFormData({
            ...form_data,
            equipments: copy_eqp,
        });
    };

    const updateLineItemEqp = (eqp, type, slug) => {
        let copy_eqp = form_data.equipments;
        let array = copy_eqp[type][slug];
        let new_array = Array.from({ length: array.length }, () => eqp);
        copy_eqp[type][slug] = new_array;

        let purchase_type = eqp.type;
        if (purchase_type !== type) {
            let copy_eqp = _.cloneDeep(form_data.equipments);
            delete copy_eqp[type][slug];
            const purchaseType = copy_eqp[purchase_type] || {};
            let new_obj = {
                ...copy_eqp,
                [purchase_type]: {
                    ...purchaseType,
                    [slug]: new_array,
                },
            };
            eventEmitter.emit("updateEquipment", new_obj);
        } else {
            setFormData({
                ...form_data,
                equipments: copy_eqp,
            });
        }
    };

    const removeEquipment = (type, slug) => {
        let copy_eqp = _.cloneDeep(form_data.equipments);
        delete copy_eqp[type][slug];
        eventEmitter.emit("updateEquipment", copy_eqp);
        setIsDeviceExpanded(false);
    };

    const [pricing_template_data, setPricingTemplateData] = useState({});
    const handleTemplateChange = (selected) => {
        const template = all_templates.find(t => t.id == selected.value);
        if(template){
          setFormData({
            ...form_data,
            equipments: {},
          });
          setPricingTemplateData(template.data);
            setIsEditable(template.is_editable == 1 ? true : false);
        }        
    };

    useEffect(() => {
      if(Object.entries(pricing_template_data).length > 0){
        setFormData({
          ...form_data,
          ebt: pricing_template_data?.ebt || "no",
            is_tm: pricing_template_data?.is_tm || "no",        
          avs_fee: pricing_template_data?.avs_fee || "0.10",
          country: pricing_template_data?.country || "en",
          etf_fee: pricing_template_data?.etf_fee || "595.00",
          tm_lead: pricing_template_data?.tm_lead || "no",
          var_only: pricing_template_data?.var_only || null,
          batch_fee: pricing_template_data?.batch_fee || "0.30",
          cold_call: pricing_template_data?.cold_call || "no",
          flat_rate: pricing_template_data?.flat_rate || "3.00",
          setup_fee: pricing_template_data?.setup_fee || "125.00",
          voice_aru: pricing_template_data?.voice_aru || "0.60",
          batch_time: pricing_template_data?.batch_time || "06:00 PM", 
          fnf_number: pricing_template_data?.fnf_number || null,
          data_breach: pricing_template_data?.data_breach || "15.00",
          monthly_fee: pricing_template_data?.monthly_fee || "49.00",
          postal_code: pricing_template_data?.postal_code || null,
          selectedOrg: pricing_template_data?.selectedOrg || null,
          ic_plus_rate: pricing_template_data?.ic_plus_rate || "0.15",
          referrer_mid: pricing_template_data?.referrer_mid || null,
          selectedUser: pricing_template_data?.selectedUser || null,        
          other_gateway: pricing_template_data?.other_gateway || null,
          pricing_model: pricing_template_data?.qualifiedtype || "dual_pricing",
          qualifiedtype: pricing_template_data?.qualifiedtype || "dual_pricing",
          referrer_name: pricing_template_data?.referrer_name || null,
          chargeback_fee: pricing_template_data?.chargeback_fee || "45.00",
          flat_rate_amex: pricing_template_data?.flat_rate_amex || "3.00",
          surcharge_rate: pricing_template_data?.surcharge_rate || "3.00",
          invoice_address: pricing_template_data?.invoice_address || "home_address",
          monthly_minimum: pricing_template_data?.monthly_minimum || "25.00",
          pre_dispute_fee: pricing_template_data?.pre_dispute_fee || "45.00",
          auth_transaction: pricing_template_data?.auth_transaction || "0.25",
          billing_sequence: pricing_template_data?.billing_sequence || "daily",
          ebt_transactions: pricing_template_data?.ebt_transactions || null,
          monthly_cellular: pricing_template_data?.monthly_cellular || "25.00",
          tiered_qual_rate: pricing_template_data?.tiered_qual_rate || "1.75",
          amex_tier_one_fee: pricing_template_data?.amex_tier_one_fee || "0.20",
          amex_tier_two_fee: pricing_template_data?.amex_tier_two_fee || "0.20",
          dual_pricing_rate: pricing_template_data?.dual_pricing_rate || 4,
          equipment_address: pricing_template_data?.equipment_address || "legal_address",
          expedited_funding: pricing_template_data?.expedited_funding || "yes",
          ic_plus_amex_rate: pricing_template_data?.ic_plus_amex_rate || "0.15",
          representment_fee: pricing_template_data?.representment_fee || "45.00",
          returned_ach_item: pricing_template_data?.returned_ach_item || "25.00",
          selected_template: pricing_template_data?.selected_template || null,
          telemarketer_name: pricing_template_data?.telemarketer_name || null,
          var_sheet_request: pricing_template_data?.var_sheet_request || "yes",
          amex_tier_four_fee: pricing_template_data?.amex_tier_four_fee || "0.20",
          amex_tier_one_rate: pricing_template_data?.amex_tier_one_rate || "3.50",
          amex_tier_two_rate: pricing_template_data?.amex_tier_two_rate || "3.50",
          cover_cancellation: pricing_template_data?.cover_cancellation || "no",
          monthly_access_fee: pricing_template_data?.monthly_access_fee || "15.00",
          amex_tier_four_rate: pricing_template_data?.amex_tier_four_rate || "3.50",
          amex_tier_three_fee: pricing_template_data?.amex_tier_three_fee || "0.20",
          reprogram_equipment: pricing_template_data?.reprogram_equipment || true,
          amex_tier_three_rate: pricing_template_data?.amex_tier_three_rate || "3.50",
          cellular_transaction: pricing_template_data?.cellular_transaction || "0.10",
          is_merchant_referral: pricing_template_data?.is_merchant_referral || "no",
          semi_annual_tech_fee: pricing_template_data?.semi_annual_tech_fee || "75.00",
          special_instructions: pricing_template_data?.special_instructions || "",
          tiered_mid_qual_rate: pricing_template_data?.tiered_mid_qual_rate || "2.29",
          tiered_non_qual_rate: pricing_template_data?.tiered_non_qual_rate || "2.99",
          flat_rate_transaction: pricing_template_data?.flat_rate_transaction || "0.15",
          surcharge_monthly_fee: pricing_template_data?.surcharge_monthly_fee || "49.00",
          tiered_amex_flat_rate: pricing_template_data?.tiered_amex_flat_rate || "3.50",
          tiered_pin_debit_rate: pricing_template_data?.tiered_pin_debit_rate || "0.00",
          who_to_deploy_gateway: pricing_template_data?.who_to_deploy_gateway || "agent",
          ic_plus_pin_debit_rate: pricing_template_data?.ic_plus_pin_debit_rate || "0.00",
          tiered_qual_debit_rate: pricing_template_data?.tiered_qual_debit_rate || "1.50",
          ic_plus_transaction_fee: pricing_template_data?.ic_plus_transaction_fee || "0.15",
          tiered_qual_transaction: pricing_template_data?.tiered_qual_transaction || "0.15",
          who_to_deploy_equipment: pricing_template_data?.who_to_deploy_equipment || "agent",
          dual_pricing_monthly_fee: pricing_template_data?.dual_pricing_monthly_fee || "49.00",
          flat_rate_pin_debit_rate: pricing_template_data?.flat_rate_pin_debit_rate || "2.00",
          reprogram_equipment_name: pricing_template_data?.reprogram_equipment_name || null,
          surcharge_pin_debit_rate: pricing_template_data?.surcharge_pin_debit_rate || "0.00",
          tiered_amex_ic_plus_rate: pricing_template_data?.tiered_amex_ic_plus_rate || "3.50",
          who_to_pay_for_equipment: pricing_template_data?.who_to_pay_for_equipment || "agent",
          surcharge_per_transaction: pricing_template_data?.surcharge_per_transaction || "0.15",
          surcharge_qual_debit_rate: pricing_template_data?.surcharge_qual_debit_rate || "1.50",
          flat_rate_amex_transaction: pricing_template_data?.flat_rate_amex_transaction || "0.15",
          tiered_mid_qual_debit_rate: pricing_template_data?.tiered_mid_qual_debit_rate || "1.99",
          tiered_non_qual_debit_rate: pricing_template_data?.tiered_non_qual_debit_rate || "2.49",
          dual_pricing_pin_debit_rate: pricing_template_data?.dual_pricing_pin_debit_rate || "0.00",
          tiered_mid_qual_transaction: pricing_template_data?.tiered_mid_qual_transaction || "0.15",
          tiered_non_qual_transaction: pricing_template_data?.tiered_non_qual_transaction || "0.15",
          ic_plus_amex_transaction_fee: pricing_template_data?.ic_plus_amex_transaction_fee || "0.15",
          tiered_amex_flat_transaction: pricing_template_data?.tiered_amex_flat_transaction || "0.20",
          tiered_pin_debit_network_fee: pricing_template_data?.tiered_pin_debit_network_fee || "yes",
          ic_plus_pin_debit_network_fee: pricing_template_data?.ic_plus_pin_debit_network_fee || "yes",
          pricing_approved_by_rate_desk: pricing_template_data?.pricing_approved_by_rate_desk || "no",
          surcharge_mid_qual_debit_rate: pricing_template_data?.surcharge_mid_qual_debit_rate || "1.99",
          surcharge_non_qual_debit_rate: pricing_template_data?.surcharge_non_qual_debit_rate || "2.49",
          surcharge_signature_debit_rate: pricing_template_data?.surcharge_signature_debit_rate || "3.00",
          flat_rate_pin_debit_network_fee: pricing_template_data?.flat_rate_pin_debit_network_fee || "yes",
          surcharge_pin_debit_network_fee: pricing_template_data?.surcharge_pin_debit_network_fee || "yes",
          tiered_amex_ic_plus_transaction: pricing_template_data?.tiered_amex_ic_plus_transaction || "0.20",
          tiered_pin_debit_per_transaction: pricing_template_data?.tiered_pin_debit_per_transaction || "0.00",
          ic_plus_pin_debit_per_transaction: pricing_template_data?.ic_plus_pin_debit_per_transaction || "0.00",
          tiered_qual_debit_per_transaction: pricing_template_data?.tiered_qual_debit_per_transaction || "0.15",
          dual_pricing_pin_debit_network_fee: pricing_template_data?.dual_pricing_pin_debit_network_fee || "yes",
          flat_rate_pin_debit_per_transaction: pricing_template_data?.flat_rate_pin_debit_per_transaction || "0.15",
          surcharge_pin_debit_per_transaction: pricing_template_data?.surcharge_pin_debit_per_transaction || "0.00",
          surcharge_qual_debit_per_transaction: pricing_template_data?.surcharge_qual_debit_per_transaction || "0.15",
          tiered_mid_qual_debit_per_transaction: pricing_template_data?.tiered_mid_qual_debit_per_transaction || "0.15",
          tiered_non_qual_debit_per_transaction: pricing_template_data?.tiered_non_qual_debit_per_transaction || "0.15",
          dual_pricing_pin_debit_per_transaction: pricing_template_data?.dual_pricing_pin_debit_per_transaction || "0.00",
          surcharge_mid_qual_debit_per_transaction: pricing_template_data?.surcharge_mid_qual_debit_per_transaction || "0.15",
          surcharge_non_qual_debit_per_transaction: pricing_template_data?.surcharge_non_qual_debit_per_transaction || "0.15",
          surcharge_signature_debit_per_transaction: pricing_template_data?.surcharge_signature_debit_per_transaction || "0.15",     
          equipments: pricing_template_data.equipments            
        });

        setInvoiceAddress(pricing_template_data?.invoice_address || "home_address");
        setEquipmentAddress(pricing_template_data?.equipment_address || "legal_address");
        setSpecialInstruction(pricing_template_data?.special_instructions || "");
        setPricingTemplateData({});
      }
    }, [pricing_template_data]);

    useEffect(() => {
        if (
            form_data?.equipments &&
            Object.entries(form_data?.equipments).length > 0
        ) {
            let category_array = [];
            let tpp_equipments = [];
            Object.entries(form_data?.equipments).forEach(
                ([purchase_type, equipments_object]) => {
                    Object.entries(equipments_object).forEach(
                        ([eqp_slug, equipments]) => {
                            if (Array.isArray(equipments)) {
                                equipments.forEach((eqp) => {
                                    category_array.push(eqp?.category_id);
                                });
                                if(purchase_type == 'apply_tpp' && equipments.length)
                                {
                                    tpp_equipments.push(eqp_slug);
                                }
                            }
                        },
                    );
                },
            );
            setCategoriesSelected(category_array);
            setTppEquipmentsSelected(tpp_equipments);
        }
    }, [form_data]);

    const equipment_addr_ref = useRef(null);
    const invoice_addr_ref = useRef(null);

    return (
        <>
            {assignBankModal && (
                <AssignBankModal
                    sendForSignature={true}
                    show={assignBankModal}
                    onClose={() => {
                        setAssignBankModal("");
                        props.close();
                    }}
                />
            )}
            <ReactModal
                isOpen={isOpen}
                contentLabel="EMS Boot Modal"
                className="add-pricing-equipment-modal"
                ref={modalContentRef}
            >
                {(preappData?.status && preappBillingData?.status) || props.template ?
                    <>
                        <div className="sticky-header">
                            <div className="icons">
                                <button
                                    className="close-modal-btn"
                                    onClick={() => props.close()}
                                    type="button"
                                >
                                    <FaTimes />
                                </button>

                                <AddedItemCount
                                    equipments={form_data?.equipments || {}}
                                    setEquipmentCount={setEquipmentCount}
                                />
                            </div>
                        </div>
                        <div className="scrollable-div">
                            {!props.template && <div className="pricing-model-container mt-4r" >
                                <p className="sub-heading-lead"> Select a template</p>
                                <Select
                                    options={templateOptions}
                                    onChange={handleTemplateChange}
                                />
                                {
                                    !isEditable && (
                                        <p className="error-message">This template data is not editable</p>
                                    )
                                }
                            </div>}

                            {isEditable && <EquipmentContext.Provider
                                value={{
                                    allEquipments,
                                    isDeviceExpanded,
                                    setIsDeviceExpanded,
                                    setErrors,
                                    categories_selected,
                                    setCategoriesSelected,
                                    org_id,
                                    tpp_equipments_selected,
                                    var_only,
                                    setVarOnly
                                }}
                            >
                                <PricingModel
                                    appId={props.appId}
                                    pricingModels={pricing_model_options}
                                    setFormDataByKeyValue={isEditable ? setFormDataByKeyValue : () => { }}
                                    setFormDataByComplete={setFormDataByComplete}
                                    errors={errors}
                                    form_data={form_data}
                                    allEquipments={allEquipments}
                                    removeError={removeError}
                                    preappData={preappData}
                                    preappBillingData={preappBillingData}
                                    template={props.template}
                                    mccList={mccList}
                                    emsOfficeList={emsOfficeList}
                                />
                                <hr className="horizontal-rule" />
                                {form_data.equipments && typeof form_data.equipments === 'object' && Object.entries(form_data.equipments).length > 0 &&
                                    equipment_count > 0 && (
                                        <LineItems
                                            equipments_data={form_data.equipments}
                                            addQuantity={addQuantity}
                                            removeQuantity={removeQuantity}
                                            updateEquipment={updateLineItemEqp}
                                            removeEquipment={removeEquipment}
                                            allEquipments={allEquipments}
                                            action={true}
                                            equipmentCount={equipment_count}
                                        />
                                    )}
                            </EquipmentContext.Provider>}
                            <div className="row">

                                <div
                                    className={
                                        org_id !== PAYCHEX_ORG_ID
                                            ? "col-12 col-md-12 col-lg-12"
                                            : "col-6 col-md-6 col-lg-6"
                                    }
                                >
                                    <SlidingButton
                                        handleChange={(_e, v) => isEditable ? setExpeditedFunding(v) : () => { }}
                                        title="Opt merchant into expedited funding?"
                                        value={expedited_funding}
                                        options={[
                                            { key: "yes", value: "Yes" },
                                            { key: "no", value: "No" },
                                        ]}
                                        className="expedited-funding mt-4r"
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6 col-md-6 col-lg-6">
                                    <SlidingButton
                                        handleChange={(_e, v) => isEditable ? setBillingSequence(v) : () => { }}
                                        title="Select the preferred billing sequence."
                                        value={billing_sequence}
                                        options={
                                            ["dual_pricing", "surcharge"].includes(
                                                form_data.pricing_model,
                                            )
                                                ? [{ key: "daily", value: "Daily" }]
                                                : [
                                                    { key: "daily", value: "Daily" },
                                                    { key: "monthly", value: "Monthly" },
                                                ]
                                        }
                                        className="billing-sequence mt-4r"
                                    />
                                </div>
                                <div className="col-6 col-md-6 col-lg-6">
                                    <div className="pricing-model-container mt-4r">
                                        <p className="sub-heading-lead">
                                            Select the desired auto batch time.
                                        </p>
                                        <div className="row">
                                            <div className="col-12 col-md-12 col-sm-12 col-lg-12">
                                                <BatchTime
                                                    onChange={(time) => {
                                                        isEditable ? setBatchTime(time) : () => { };
                                                        removeError("batch_time");
                                                    }}
                                                    errors={errors}
                                                    value={batch_time}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {errors?.batch_time &&
                                        Array.isArray(errors.batch_time) &&
                                        errors.batch_time.map((error, index) => (
                                            <span key={index} className="error-message">{error}</span>
                                        ))}
                                </div>
                            </div>

                            <div
                                className="pricing-model-container mt-4r"
                                tabindex="-1"
                                ref={equipment_addr_ref}
                            >
                                <p className="sub-heading-lead">
                                    Select the address we should ship the equipment to
                                </p>
                                <Stack
                                    direction={{ xs: "column", sm: "row" }}
                                    className="pricing-model-buttons"
                                >
                                    <button
                                        type="button"
                                        className={
                                            equipment_address == "legal_address"
                                                ? "active"
                                                : ""
                                        }
                                        onClick={() => {
                                            setEquipmentAddress("legal_address");
                                            removeError("equipment_address");
                                        }}
                                        disabled={!isEditable}
                                    >
                                        {equipment_address == "legal_address" ? (
                                            <IoMdCheckmark />
                                        ) : (
                                            ""
                                        )}{" "}
                                        Legal Address
                                    </button>
                                    <button
                                        type="button"
                                        className={
                                            equipment_address == "home_address"
                                                ? "active"
                                                : ""
                                        }
                                        onClick={() => {
                                            setEquipmentAddress("home_address");
                                            removeError("equipment_address");
                                        }}
                                        disabled={!isEditable}
                                    >
                                        {equipment_address == "home_address" ? (
                                            <IoMdCheckmark />
                                        ) : (
                                            ""
                                        )}{" "}
                                        Home Address
                                    </button>
                                    <button
                                        type="button"
                                        className={
                                            equipment_address == "dba_address"
                                                ? "active"
                                                : ""
                                        }
                                        onClick={() => {
                                            setEquipmentAddress("dba_address");
                                            removeError("equipment_address");
                                        }}
                                        disabled={!isEditable}
                                    >
                                        {equipment_address == "dba_address" ? (
                                            <IoMdCheckmark />
                                        ) : (
                                            ""
                                        )}{" "}
                                        DBA Address
                                    </button>

                                </Stack>
                            </div>
                            {errors?.equipment_address &&
                                Array.isArray(errors.equipment_address) &&
                                errors.equipment_address.map((error, index) => (
                                    <span key={index} className="error-message">{error}</span>
                                ))}

                            <div
                                className="pricing-model-container mt-4r"
                                tabindex="-1"
                                ref={invoice_addr_ref}
                            >
                                <p className="sub-heading-lead">
                                    Select the address we should send the invoice to
                                </p>
                                <Stack
                                    direction={{ xs: "column", sm: "row" }}
                                    className="pricing-model-buttons"
                                >
                                    <button
                                        type="button"
                                        className={
                                            invoice_address == "legal_address"
                                                ? "active"
                                                : ""
                                        }
                                        onClick={() => {
                                            setInvoiceAddress("legal_address");
                                            removeError("invoice_address");
                                        }}
                                        disabled={!isEditable}
                                    >
                                        {invoice_address == "legal_address" ? (
                                            <IoMdCheckmark />
                                        ) : (
                                            ""
                                        )}{" "}
                                        Legal Address
                                    </button>
                                    <button
                                        type="button"
                                        className={
                                            invoice_address == "home_address"
                                                ? "active"
                                                : ""
                                        }
                                        onClick={() => {
                                            setInvoiceAddress("home_address");
                                            removeError("invoice_address");
                                        }}
                                        disabled={!isEditable}
                                    >
                                        {invoice_address == "home_address" ? (
                                            <IoMdCheckmark />
                                        ) : (
                                            ""
                                        )}{" "}
                                        Home Address
                                    </button>
                                    <button
                                        type="button"
                                        className={
                                            invoice_address == "dba_address" ? "active" : ""
                                        }
                                        onClick={() => {
                                            setInvoiceAddress("dba_address");
                                            removeError("invoice_address");
                                        }}
                                        disabled={!isEditable}
                                    >
                                        {invoice_address == "dba_address" ? (
                                            <IoMdCheckmark />
                                        ) : (
                                            ""
                                        )}{" "}
                                        DBA Address
                                    </button>

                                </Stack>
                            </div>
                            {errors?.invoice_address &&
                                Array.isArray(errors.invoice_address) &&
                                errors.invoice_address.map((error, index) => (
                                    <span key={index} className="error-message">{error}</span>
                                ))}

                            <div className="pricing-model-container mt-4r">
                                <div className="row">
                                    <div className="col-12 col-md-12 col-sm-12 col-lg-12">
                                        <div className="floating-form textarea-field">
                                            <Form.Group size="lg" controlId="dba_name">
                                                <Form.Control
                                                    placeholder=""
                                                    name="special_instructions"
                                                    value={special_instructions}
                                                    onChange={(e) =>
                                                        setSpecialInstruction(
                                                            e.target.value,
                                                        )
                                                    }
                                                    className="input-control"
                                                    as="textarea"
                                                />
                                                <Form.Label className="floating-label">
                                                    Special Instructions
                                                </Form.Label>
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {Object.entries(errors).length > 0 ? (
                                <>
                                    <p className="error-message mt-2r all-errors">
                                        Please fix the following fields:
                                        <br />
                                        <span className="bold-error">
                                            {Object.entries(errors).map(([key, error], index) => (
                                                <span key={index}>
                                                    {key.includes('.') ? key.split('.')[0].replace(/_/g, " ") : key.replace(/_/g, " ")}: {error}
                                                    <br />
                                                </span>
                                            ))}
                                        </span>
                                    </p>
                                </>
                            ) : (
                                <></>
                            )}
                            {errors?.error &&
                                Array.isArray(errors.error) &&
                                errors.error.map((error, index) => (
                                    <span key={index} className="error-message">{error}</span>
                                ))}
                            <Stack
                                direction={{ xs: "column", sm: "row" }}
                                className="submit-section"
                            >
                                <button
                                    type="button"
                                    className="generate-app"
                                    onClick={(e) => submitForm(e, 'save')}
                                    disabled={Object.entries(errors).length > 0}
                                >
                                    Save
                                </button>
                                {!props.template && <button
                                    type="button"
                                    className="generate-app"
                                    onClick={(e) => submitForm(e, 'save_send')}
                                    disabled={Object.entries(errors).length > 0}
                                >
                                    Save & Send for Signature
                                </button>}

                            </Stack>
                        </div>
                    </> :
                    <div className="row" style={{
                        height: "100px"
                    }}>
                        <div className="col-3 col-md-3 col-lg-3"></div>
                        <div className="col-6 col-md-6 col-lg-6">
                            <div
                                className="scrollable-div"
                                style={{
                                    position: "absolute",
                                    transform: "translate(-50%, -50%)",
                                    left: "50%",
                                    right: "50%"
                                }}
                            >
                                <Loader />
                            </div>
                        </div>
                        <div className="col-3 col-md-3 col-lg-3"></div>
                    </div>
                }
            </ReactModal>
        </>

    );
}

export default AddPricingEquipmentModal;
